export const appDownLink = 'https://applink.heydealer.com/QbFw/HomepageMobile';
